import React, { Component } from 'react';
import {
  ActivityIndicator,
  Alert,
  Dimensions,
  Image,
  InteractionManager,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import _ from 'lodash';
import { FontAwesomeIcon, KeyboardAwareScrollView } from '../modules';
import LoadingIndicator from '../common/LoadingIndicator';
import APIClient from '../utils/APIClient';
import Utils from '../utils/Utils';
import AlertUtils from '../utils/AlertUtils';

const contentWidth = Math.min(Dimensions.get('window').width - 40, 300);

class SellerScreen extends Component {

  static navigationOptions = ({navigation}) => {
    return {
      title: 'Cập nhật thông tin',
      headerBackTitle: null,
    };
  };

  constructor (props) {
    super(props);

    if (Platform.OS === 'web') {
      this._id = this.props.match.params.id;
    } else {
      this._id = this.props.navigation.state.params.id;
    }

    this.state = {
      status: 'none',
    };
  }

  componentDidMount () {
    if (Platform.OS === 'web') {
      this._loadData();
    } else {
      InteractionManager.runAfterInteractions(() => {
        this._loadData();
      });
    }
  }

  componentWillUnmount () {
  }

  componentWillReceiveProps (nextProps) {
  }

  _updateInputValue (name, value) {
    this.setState({
      [name]: value,
    });
  }

  _focusTextInput (name) {
    const textInput = this.refs[name];
    if (textInput) {
      textInput.focus();
    }
  }

  _loadData = async () => {
    const {status} = this.state;
    if (status === 'loading') {
      return;
    }

    this.setState({
      status: 'loading',
    });

    const path = `/seller/${this._id}`;
    const {response, error} = await APIClient.GET(path);
    this._handleNetworkResponse(response, error);
  };

  _handleNetworkResponse (response, error) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    if (response && response.response) {
      this._updateData(response.response);
    } else {
      const message = Utils.parseErrorMessage(response, error,
        'Có lỗi xảy ra, vui lòng thử lại sau');
      AlertUtils.alert({message});
      this.setState({
        status: 'failed',
      });
    }
  }

  _updateData = (data) => {
    const {promoCode, commission, multilevelCommission} = data;
    this.setState({
      data: data,
      promoCode: promoCode,
      commission: `${commission}`,
      multilevelCommission: `${multilevelCommission}`,
      status: 'done',
    });
  };

  _submit = async () => {
    const {submitting} = this.state;
    if (submitting) {
      return;
    }

    const {data, promoCode, commission, multilevelCommission} = this.state;
    let errorMessage, inputRefName;
    if (_.isEmpty(promoCode)) {
      errorMessage = 'Vui lòng điền mã giới thiệu';
      inputRefName = 'promoCodenTextInput';
    } else if (_.isEmpty(commission)) {
      errorMessage = 'Vui lòng điền hoa hồng';
      inputRefName = 'commissionTextInput';
    } else if (data.role === 'partner' && _.isEmpty(multilevelCommission)) {
      errorMessage = 'Vui lòng điền hoa hồng liên kết';
      inputRefName = 'multilevelCommissionTextInput';
    }

    if (errorMessage) {
      AlertUtils.alert({
        message: errorMessage,
        actions: [
          {text: 'OK', onPress: () => this._focusTextInput(inputRefName)},
        ],
      });
      if (Platform.OS === 'web') {
        this._focusTextInput(inputRefName);
      }
      return;
    }

    this.setState({
      submitting: true,
    });

    const path = `/seller/${this._id}`;
    const postData = {
      promoCode: promoCode,
      commission,
    };
    if (data.role === 'partner') {
      postData.multilevelCommission = multilevelCommission;
    }
    const {response, error} = await APIClient.PUT(path, postData);
    this._handleSubmitNetworkResponse(response, error);
  };

  _handleSubmitNetworkResponse (response, error) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    this.setState({
      submitting: false,
    });

    let message;
    if (response && response.response) {
      message = Utils.parseSuccessMessage(response,
        'Cập nhật thông tin thành công');
    } else {
      message = Utils.parseErrorMessage(response, error,
        'Cập nhật thông tin thất bại, vui lòng thử lại sau');
    }

    if (Platform.OS === 'web') {
      alert(message);
    } else {
      Alert.alert(
        global.__APP_NAME__,
        message,
      );
    }
  }

  render () {
    const {data, status, promoCode, commission, multilevelCommission, submitting} = this.state;
    return (
      <View
        style={styles.container}>
        {status === 'done' && <KeyboardAwareScrollView
          automaticallyAdjustContentInsets={false}
          keyboardDismissMode={Platform.OS === 'ios' ? 'on-drag' : 'none'}
          keyboardShouldPersistTaps='always'
          containerContentStyle={styles.contentContainer}
          style={styles.container}>

          <Text
            style={styles.inputTitleText}>
            Mã giới thiệu
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='promoCodeTextInput'
              value={promoCode}
              placeholder='Mã giới thiệu'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              returnKeyType={'next'}
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('promoCode',
                text)}
              onSubmitEditing={() => this._focusTextInput(
                'ommissionTextInput')}/>
          </View>

          <Text
            style={styles.inputTitleText}>
            Hoa hồng
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='commissionTextInput'
              value={commission}
              placeholder='Hoa hồng'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              keyboardType='numeric'
              returnKeyType={data.role === 'partner' ? 'next' : 'go'}
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('commission',
                text)}
              onSubmitEditing={() => data.role === 'partner'
                ? this._focusTextInput('multilevelCommissionTextInput')
                : this._submit}/>
          </View>

          {data.role === 'partner' && <Text
            style={styles.inputTitleText}>
            Hoa hồng liên kết
          </Text>}
          {data.role === 'partner' && <View
            style={styles.input}>
            <TextInput
              ref='multilevelCommissionTextInput'
              value={multilevelCommission}
              placeholder='Hoa hồng liên kết'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              keyboardType='numeric'
              returnKeyType='next'
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue(
                'multilevelCommission', text)}
              onSubmitEditing={this._submit}/>
          </View>}

          <TouchableOpacity
            activeOpacity={0.75}
            onPress={this._submit}
            style={styles.submit}>
            <Image
              source={require('../img/btn.png')}
              style={styles.submitImage}/>
            <Text
              style={styles.submitText}>
              CẬP NHẬT
            </Text>
            {submitting && <View
              style={styles.submitting}>
              <ActivityIndicator
                animating
                color='#ffffff'
                style={styles.submittingIndicator}/>
            </View>}
          </TouchableOpacity>
        </KeyboardAwareScrollView>}

        {status === 'loading' && <LoadingIndicator/>}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },
  content: {
    flex: 1,
  },
  contentContainer: {},

  inputTitleText: {
    width: contentWidth,
    marginTop: 16,
    alignSelf: 'center',
    color: '#000000',
    fontSize: 16,
    fontWeight: '300',
    backgroundColor: 'transparent',
  },
  input: {
    width: contentWidth,
    height: 44,
    marginTop: 5,
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#e2d7ba',
    backgroundColor: '#ffffff',
  },
  textInput: {
    marginLeft: 12,
    padding: 0,
    color: '#51585e',
    fontSize: 17,
    fontWeight: '300',
    backgroundColor: 'transparent',
    ...Platform.select({
      web: {
        outline: 'transparent',
      },
    }),
  },

  submit: {
    width: contentWidth,
    height: 56,
    marginTop: 24,
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  submitImage: {
    position: 'absolute',
    top: 0, left: 0,
    width: contentWidth,
    height: 56,
    resizeMode: 'stretch',
  },
  submitText: {
    color: '#ffffff',
    fontSize: 20,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
    zIndex: 1,
  },
  submitting: {
    position: 'absolute',
    top: 0, bottom: 0, right: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  submittingIndicator: {},
});

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

// export default connect(mapStateToProps, mapDispatchToProps)(CreateAgencyScreen);
export default SellerScreen;



// WEBPACK FOOTER //
// ./src/seller/SellerScreen.js